// extracted by mini-css-extract-plugin
module.exports = {"grid":"Masonry_grid__3G6pj","gridColumn":"Masonry_gridColumn__42Yzw"};